<div class="main-container">
  <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Cambiar propietario del prospecto</h4><h6 class="color-gray" style="font-weight: 400;">Seleccioa el nuevo propietario para este prospecto</h6></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>

    <div class="mdl-body">
      <div class="mt-3">
        <label class="login-label" for="newOwner">Relacionado con:</label>
        <div style="border: solid 1px #D9D9D9; padding: 4px 10px;">
        <div class="d-grid crm-ng-select">
          <div><img src="assets/svg/user-icon.svg" alt="icono asignado"></div>
          <div>
            <ng-select class="crm-ng-select"
              *ngIf="users"
              [items]="users"
              bindLabel="nombreCompleto"
              bindValue="usuario_id"
              placeholder="Buscar usuarios..."
              [(ngModel)]="selectedOwner"
              [searchable]="true"
              [clearable]="true">
            </ng-select>
          </div>
        </div>
        </div>
      </div>

      <div class="mt-3">
        <label class="crm-checkbox-label">
          <input type="checkbox" class="crm-checkbox" [(ngModel)]="sendEmail">
          <span class="crm-checkbox-custom"></span>
          Enviar notificación por correo electrónico al nuevo propietario del prospecto
        </label>
      </div>

      <div class="mt-3" *ngIf="prospectData">
        <b>El nuevo propietario </b>será también el propietario de los registros relacionados con <strong>{{ prospectData?.nombre }} {{ prospectData?.apellido }}</strong>,
        propiedad de <strong>{{ nombreCompletoseleccionado }}</strong>:
        <ul>
          <li>Notas y archivos adjuntos.</li>
          <li>Actividades abiertas.</li>
        </ul>
      </div>

      <hr class="mt-4">

      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
        <button class="btn btn-primary" (click)="saveChange()">Cambiar Propietario</button>
      </div>
    </div>
  </div>
</div>
